{
  "es-CR": {
    "account_connection_statuses": {
      "connected": "Conectado",
      "expired": "Vencido"
    },
    "account_settings": {
      "currencies_options": {
        "crc": "Colón (₡)",
        "eur": "Euro (€)",
        "usd": "Dólar ($)"
      },
      "custom_fields": {
        "description1": "Descripción general",
        "description2": "Segunda descripción",
        "description3": "Tercera descripción",
        "location": "Bodega"
      },
      "custom_labels": "Renombrar etiquetas",
      "customer_categories_labels": "Categorías de clientes",
      "customer_title": "Clientes",
      "general_base_currency": "Moneda base de conversión",
      "general_currencies": "Monedas",
      "general_title": "General",
      "inventory_title": "Inventarios",
      "list_currencies": "Monedas",
      "list_view": "Información a mostrar en la lista",
      "locations_labels": "Ubicaciones",
      "logo": "Logo",
      "measure_units": "Unidades de medida",
      "product_categories_labels": "Categorías de artículos",
      "regional": "Configuración regional",
      "type_cost": "Tipo de costo"
    },
    "actions": {
      "activate": "Activar",
      "add": "Agregar",
      "add_new": "Crear",
      "apply": "Aplicar",
      "cancel": "Cancelar",
      "change_password": "Cambiar Contraseña",
      "choose_file": "Seleccionar Archivo",
      "clear": "Limpiar",
      "clear_all": "Limpiar todo",
      "clear_search_filters": "Borrar filtros",
      "close": "Cerrar",
      "copy": "Copiar",
      "deactivate": "Desactivar",
      "delete": "Borrar",
      "download_xml": "Descargar XML",
      "edit": "Editar",
      "finalize": "Finalizar",
      "generate": "Generar",
      "import": "Importar",
      "nested_form": {
        "credit_note": {
          "items": "Agregar producto"
        },
        "customer": {
          "bank_accounts": "Agregar cuenta bancaria",
          "contacts": "Agregar contacto",
          "exonerations": "Agregar exoneración"
        },
        "inventory_adjustment": {
          "items": "Agregar producto"
        },
        "physical_inventory": {
          "physical_inventory_items": "Agregar producto"
        },
        "product": {
          "equivalencies": "Agregar equivalencia",
          "location_products": "Agregar ubicación"
        },
        "purchase": {
          "items": "Agregar producto"
        },
        "purchase_order": {
          "items": "Agregar producto"
        },
        "sales_order": {
          "items": "Agregar producto"
        },
        "vendor": {
          "bank_accounts": "Agregar cuenta bancaria",
          "contacts": "Agregar contacto"
        }
      },
      "ok": "Aceptar",
      "print": "Imprimir",
      "print_barcode": "Imprimir Código de barras",
      "print_pdf": "Imprimir PDF",
      "save": "Guardar",
      "search": "Buscar",
      "see_by": "Ver",
      "sort_by": "Ordenar por"
    },
    "activemodel": {
      "attributes": {
        "irazu/account_connection": {
          "certificate": "Certificado",
          "certificate_password": "Código del certificado",
          "password": "Contraseña",
          "username": "Nombre de usuario"
        },
        "line_tax": {
          "code": "Código",
          "rate_code": "Código de tarifa"
        },
        "sales_order/finalize": {
          "emails": "Correos electrónicos",
          "sales_order": "Orden de venta",
          "send_email": "¿Enviar correo electrónico?"
        }
      },
      "errors": {
        "models": {
          "sales_order/finalize": {
            "attributes": {
              "base": {
                "invalid_items": "El documento tiene ítemes con errores",
                "invalid_tasks": "El documento tiene tareas con errores",
                "missing_items": "El documento debe tener al menos una línea de detalle"
              },
              "sales_order": {
                "already_finalized": "ya ha sido finalizada anteriormente"
              }
            }
          }
        }
      }
    },
    "activerecord": {
      "attributes": {
        "account": {
          "email": "Correo electrónico",
          "fax": "Fax",
          "general_base_currency": "Moneda base de conversión",
          "general_cost_type": "Tipo de costo",
          "general_cost_types": {
            "entries_average": "Costo promedio",
            "last_entry": "Costo última entrada"
          },
          "general_currencies": "Monedas",
          "general_regional_delimiter": "Delimitador de miles",
          "general_regional_precision": "Precisión",
          "general_regional_separator": "Separador de decimales",
          "general_regional_strip_insignificant_zeros": "Excluir ceros a la derecha",
          "inventory_list_display_modes": {
            "description": "Desplegar nombre y la descripción",
            "sku": "Desplegar nombre y el SKU"
          },
          "inventory_units_of_measure": "Unidades de medida",
          "name": "Nombre",
          "phone": "Número de teléfono",
          "tenant_name": "Subdominio"
        },
        "account/factura_electronica_setting": {
          "certificate": "Certificado",
          "default_branch_office": "Sucursal por defecto",
          "default_pos": "Número de caja por defecto",
          "factura_electronica_activity": "Actividad",
          "factura_electronica_activity_id": "Códidog de Actividad"
        },
        "account/identifier": {
          "identifier": "Número de identificación",
          "identifier_type": "Tipo de identificación"
        },
        "account_user": {
          "account_id": "Cuenta",
          "location_ids": "Ubicaciones",
          "role_id": "Rol",
          "user_id": "Usuario",
          "vendor_code": "Código de vendedor"
        },
        "account_user/user": {
          "created_at": "Creado en",
          "email": "Correo electrónico",
          "full_name": "Nombre Completo",
          "last_sign_in_at": "Fecha del último ingreso"
        },
        "address": {
          "canton": "Cantón",
          "district": "Distrito",
          "province": "Provincia",
          "street_line1": "Calle 1",
          "street_line2": "Calle 2"
        },
        "bank_account": {
          "account_number": "Número de cuenta",
          "currency": "Moneda",
          "name": "Nombre",
          "notes": "Notas"
        },
        "category": {
          "name": "Nombre"
        },
        "contact": {
          "archived": "Archivado?",
          "contact_id": "Número de indentificación",
          "email": "Correo electrónico",
          "name": "Nombre",
          "notes": "Notas",
          "phone": "Número de teléfono"
        },
        "credit_note": {
          "date_time": "Fecha"
        },
        "customer": {
          "categories": "Categorías",
          "name": "Nombre",
          "primary_contact": "Contacto Principal"
        },
        "document": {
          "branch_office": "Sucursal",
          "credit_term": "Plazo del crédito",
          "currency": "Moneda",
          "customer": "Cliente",
          "date_time": "Fecha",
          "discount": "Descuento",
          "document_type": "Tipo de documento",
          "exchange_rate_crc": "Colón (₡)",
          "exchange_rate_eur": "Euro (€)",
          "exchange_rate_usd": "USD ($)",
          "exchange_rates": "Tipos de cambio",
          "factura_electronica_activity": "Actividad",
          "factura_electronica_activity_id": "Actividad",
          "location": "Ubicación",
          "location_id": "Ubicación",
          "number": "Número",
          "payment_methods": "Métodos de pago",
          "pos": "Punto de venta",
          "pricing_list_id": "Lista de precios",
          "reference_code": "Código de referencia",
          "sale_condition": "Condición de venta",
          "submission_statuses": {
            "accepted": "Aceptada",
            "pending": "Enviando",
            "rejected": "Rechazada",
            "submitted": "Enviada"
          },
          "taxes": "Impuestos",
          "vendor": "Proveedor"
        },
        "document/items": {
          "code": "Código del ítem",
          "cost": "Costo",
          "description": "Descripción",
          "discount": "Desc.",
          "price": "Precio",
          "product": "Producto",
          "quantity": "Cantidad",
          "quantity_with_unit": "Cantidad",
          "subtotal": "Subtotal",
          "taxes": "IVA",
          "title": "Ítem",
          "total_taxes": "IVA",
          "unit_of_measure": "Unidad de medida del ítem"
        },
        "document/items/taxes": {
          "amount": "Monto",
          "code": "Código",
          "rate": "Tarifa I.V.A.",
          "rate_code": "Código de tarifa"
        },
        "document_line": {
          "code": "Código",
          "cost": "Costo",
          "discount": "Descuento",
          "price": "Precio",
          "product": "Producto",
          "product_id": "Producto",
          "quantity": "Cantidad",
          "quantity_with_unit": "Cantidad",
          "subtotal": "Subtotal",
          "taxes": "Impuestos",
          "unit_of_measure": "Unidad de medida",
          "vendor_code": "Código del vendedor"
        },
        "document_payment": {
          "amount": "Monto",
          "date": "Fecha",
          "notes": "Notas",
          "payment_method": "Método de pago",
          "reference": "Referencia"
        },
        "equivalency": {
          "base_quantity": "Cantidad unidad standard",
          "equivalence": "Cantidad equivalente",
          "equivalency_id": "Equivalencia",
          "unit_of_measure": "Unidad de medida"
        },
        "exoneration": {
          "all_products": "Todos los productos",
          "authorization": "Autorización",
          "authorization_type": "Tipo de autorización",
          "cabys_codes": "Códigos Cabys",
          "date_emission": "Fecha de emisión",
          "document_number": "Número de documento",
          "document_type_code": "Código de tipo de documento",
          "document_type_description": "Descripción de tipo de documento",
          "due_date": "Fecha de vencimiento",
          "has_cabys": "Tiene códigos CABYS",
          "identification": "Identificación",
          "institution_name": "Nombre de institución",
          "percentage": "Porcentaje de exoneración"
        },
        "factura_electronica/document": {
          "confirmed_document_key": "Clave de documento"
        },
        "identifier": {
          "identifier": "Número de identificación",
          "identifier_type": "Tipo de identificación"
        },
        "inventory_adjustment/items": {
          "price": "Costo"
        },
        "location": {
          "allow_customer_returns": "Permitir devolución de clientes",
          "allow_purchases": "Permitir compras",
          "allow_sales": "Permitir ventas",
          "code": "Código",
          "created_at": "Fecha de creación",
          "name": "Nombre",
          "parent": "Ubicación padre",
          "permission": {
            "0": "No",
            "1": "Si"
          }
        },
        "location_product": {
          "location_id": "Ubicación",
          "max_inventory": "Máximo",
          "min_inventory": "Mínimo",
          "reorder_point": "Punto reorden"
        },
        "paper_trail/version": {
          "created_at": "Fecha",
          "event": "Evento",
          "item_type": "Módulo",
          "user/first_name": "Usuario",
          "whodunnit": "Usuario"
        },
        "physical_inventory": {
          "created_at": "Fecha",
          "inventory_adjustment_id": "Ajuste inventario físico",
          "inventory_status": "Estado",
          "inventory_statuses": {
            "applied": "Aplicado",
            "draft": "Borrador",
            "unknown": "Desconocido"
          },
          "location_id": "Ubicación",
          "notes": "Notas"
        },
        "physical_inventory_item": {
          "code": "Código",
          "description": "Descripción",
          "product": "Producto",
          "product_id": "Producto",
          "quantity": "Cantidad",
          "quantity_with_unit": "Cantidad",
          "unit_of_measure": "Unidad de medida"
        },
        "pricing_list": {
          "name": "Nombre",
          "product": "Producto",
          "valid_from": "Válida desde",
          "valid_until": "Válida hasta"
        },
        "pricing_list/product": {
          "price_value": "Valor",
          "type": "Tipo",
          "value": "Valor"
        },
        "pricing_list_product": {
          "price_value": "Valor",
          "type": "Tipo",
          "value": "Valor"
        },
        "pricing_plan": {
          "code": "Código",
          "description": "Descripción",
          "documents_allowed": "Documentos permitidos",
          "monthly_amount": "Monto mensual",
          "name": "Nombre",
          "users_allowed": "Usuarios permitidos",
          "yearly_amount": "Monto anual"
        },
        "product": {
          "barcode": "Código de barras",
          "cabys_code": "Código CABYS",
          "categories": "Categorías",
          "code": "Código",
          "cost": "Costo",
          "description": "Descripción",
          "description2": "Descripción 2",
          "description3": "Descripción 3",
          "height": "Alto",
          "iva_code": "Porcentaje IVA",
          "length": "Largo",
          "quantity": "Cantidad",
          "quantity_with_unit": "Cantidad",
          "service": "Es un servicio",
          "sku": "SKU",
          "status": "Estado",
          "unit_of_measure": "Unidad de medida",
          "unit_price": "Precio unitario",
          "weight": "Peso",
          "width": "Ancho"
        },
        "purchase": {
          "statuses": {
            "canceled": "Anulada",
            "draft": "Borrador",
            "finalized": "Finalizada",
            "paid": "Cancelada",
            "partially_paid": "Parcialmente Cancelada",
            "refunded": "Reintegrada",
            "sending": "Enviando"
          }
        },
        "purchase_order/items": {
          "price": "Costo"
        },
        "return_item": {
          "code": "Código",
          "cost": "Costo",
          "discount": "Descuento",
          "price": "Precio",
          "product": "Producto",
          "product_id": "Producto",
          "quantity": "Cantidad",
          "quantity_with_unit": "Cantidad",
          "subtotal": "Subtotal",
          "taxes": "Impuestos",
          "unit_of_measure": "Unidad de medida",
          "vendor_code": "Código del vendedor"
        },
        "role": {
          "name": "Nombre",
          "permissions": "Permisos"
        },
        "sales_order": {
          "returns": "Devoluciones",
          "statuses": {
            "canceled": "Anulada",
            "draft": "Borrador",
            "finalized": "Finalizada",
            "paid": "Cancelada",
            "partially_paid": "Parcialmente Cancelada",
            "refunded": "Reintegrada",
            "sending": "Enviando",
            "viewed": "Vista"
          }
        },
        "sales_order/returns": {
          "date_time": "Fecha de la devolución"
        },
        "sales_order/returns/items": {
          "cost": "Costo del ítem devuelto"
        },
        "user": {
          "admin": "Administrador",
          "confirmation_sent_at": "Confirmación enviada a",
          "confirmation_token": "Código de confirmación",
          "confirmed_at": "Confirmado en",
          "created_at": "Creado en",
          "current_password": "Contraseña actual",
          "current_sign_in_at": "Fecha del ingreso actual",
          "current_sign_in_ip": "IP del ingreso actual",
          "email": "Correo electrónico",
          "encrypted_password": "Contraseña cifrada",
          "failed_attempts": "Intentos fallidos",
          "first_name": "Primer nombre",
          "full_name": "Nombre completo",
          "last_name": "Apellidos",
          "last_sign_in_at": "Fecha del último ingreso",
          "last_sign_in_ip": "IP del último inicio",
          "locked_at": "Fecha de bloqueo",
          "password": "Contraseña",
          "password_confirmation": "Confirmación de la contraseña",
          "remember_created_at": "Fecha de 'Recordarme'",
          "remember_me": "Recordarme",
          "reset_password_sent_at": "Fecha de envío de código para contraseña",
          "reset_password_token": "Código para restablecer contraseña",
          "sign_in_count": "Cantidad de ingresos",
          "unconfirmed_email": "Email no confirmado",
          "unlock_token": "Código de desbloqueo",
          "updated_at": "Actualizado en"
        },
        "vendor": {
          "name": "Nombre",
          "primary_contact": "Contacto Principal",
          "primary_contact/name": "Contacto Principal"
        }
      },
      "enums": {
        "document": {
          "payment_method": null,
          "status": {
            "aceptado": "Aceptada",
            "canceled": "Anulada",
            "draft": "Borrador",
            "enviado": "Enviada",
            "paid": "Pagada",
            "partially_paid": "Pago Parcial",
            "pending": "Pendiente",
            "preparando": "Preparando",
            "procesando": "Procesando",
            "rechazado": "Rechazada",
            "refunded": "Reintegrado",
            "sending": "Enviando",
            "sent": "Enviada",
            "viewed": "Vista"
          }
        }
      },
      "errors": {
        "messages": {
          "content_type_invalid": "es un formato inválido",
          "dimension_height_equal_to": "alto debe ser igual a %{length} pixeles",
          "dimension_max_inclusion": "debe ser menor o igual %{width} x %{height} pixeles",
          "dimension_min_inclusion": "deber ser mayor o igual a %{width} x %{height} pixeles",
          "dimension_width_equal_to": "ancho debe ser igual a %{length} pixeles",
          "factura_electronica_number_greater_than_0": "El número tiene que ser mayor a cero",
          "file_size_out_of_range": "tamaño %{file_size} no está en el rango requerido",
          "image_metadata_missing": "no es una imagen válida",
          "invalid_contry_code": "no tiene un código de pais válido",
          "invalid_date": "no puede ser menor a la fecha actual",
          "invalid_email_format": "no es un correo electrónico válido",
          "invalid_phone_number": "no es un número de teléfono válido",
          "other_document_number": "ya existe para el cliente %{customer}",
          "record_invalid": "La validación falló: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No se puede eliminar el registro porque existen %{record} dependientes",
            "has_one": "No se puede eliminar el registro porque existe un %{record} dependiente"
          }
        },
        "models": {
          "account": {
            "attributes": {
              "base": {
                "invalid_grant": "Usuario/Contraseña inválido"
              },
              "general_base_currency": {
                "inclusion": "debe ser una de las monedas seleccionadas"
              },
              "general_regional_delimiter": {
                "cannot_be_equal_to_regional_separator": "no puede ser igual al separador de decimales"
              }
            }
          },
          "account_user": {
            "attributes": {
              "user_id": {
                "taken": "El usuario ya se encuentra registrado en la cuenta"
              }
            }
          },
          "credit_note": {
            "attributes": {
              "base": {
                "failed_to_create": "No se ha podido crear debido a un error. Por contacte a soporte."
              }
            }
          },
          "document": {
            "attributes": {
              "base": {
                "already_finalized": "El documento ya ha sido finalizado anteriormente",
                "cannot_destroy_fe": "El documento con clave %{key} no puede ser borrado porque ya ha sido enviado a Hacienda",
                "non_editable": "El documento ha sido enviado a hacienda y no puede ser editado"
              },
              "document_type": {
                "contact_not_in_costa_rica": "no es válido para contactos con dirección fuera de Costa Rica."
              },
              "payment_methods": {
                "too_many": {
                  "one": "son muchos (máximo 1)",
                  "other": "son muchos (máximo %{count})"
                },
                "too_short": {
                  "one": "no es válido. Se seleccionar al menos uno.",
                  "other": "no es válido. Se seleccionar al menos %{count}."
                }
              }
            }
          },
          "document_line": {
            "attributes": {
              "price": {
                "cant_be_less_than_cost": "no puede ser menor que el costo"
              },
              "product": {
                "inactive": "está inactivo",
                "not_in_location": "no se encuentra en la ubicación seleccionada",
                "not_in_price_list": "no se encuentra en la lista de precios seleccionada"
              },
              "quantity": {
                "greater_than_order_quantity": "no puede ser mayor que la cantidad de la orden de compra"
              },
              "quantity_with_unit": {
                "cant_be_greater_than_balance": "no puede ser mayor que el saldo",
                "cant_be_less_than_received_quantity": "no puede ser menor que la cantidad recibida",
                "greater_than_order_quantity": "no puede ser mayor que la cantidad de la orden de compra"
              },
              "taxes": {
                "code_blank": "el código del impuesto no puede estar en blanco",
                "rate_blank": "la tarifa del impuesto no puede estar en blanco"
              }
            },
            "cant_destroy_order_with_received_items": "No se puede eliminar esta línea porque ya se recibieron ítems"
          },
          "document_payment": {
            "attributes": {
              "amount": {
                "less_than_or_equal_to": "debe ser menor o igual que el pendiente de la factura (%{count})"
              }
            }
          },
          "equivalency": {
            "attributes": {
              "unit_of_measure": {
                "same_unit_of_measurement": "debe ser distinta a la standard",
                "taken": "está repetida"
              }
            }
          },
          "exoneration": {
            "attributes": {
              "document_number": {
                "identification_not_valid": "no pertenece a este cliente"
              }
            }
          },
          "expense": {
            "attributes": {
              "contact": {
                "identifier_required": "debe tener una identificación válida",
                "street_address_required": "no tiene información de calle, este campo es requerido para poder crear un factura de compra"
              }
            }
          },
          "factura_electronica/document": {
            "attributes": {
              "confirmed_document_key": {
                "taken": "ya existe, esto quiere decir que este documento ya ha sido confirmado anteriormente"
              }
            }
          },
          "factura_electronica/setting": {
            "attributes": {
              "certificate": {
                "invalid_certificate": "y/o contraseña no válidos"
              },
              "factura_electronica_activity_id": {
                "inclusion": "no es un código reconocido por el sistema"
              }
            }
          },
          "income": {
            "attributes": {
              "contact": {
                "not_foreign_address": "debe tener una dirección en el extranjero",
                "not_foreign_identifier": "debe tener un número de identificación válido"
              }
            }
          },
          "location": {
            "attributes": {
              "parent": {
                "is_used_in_documents": "tiene documentos asociados y no puede tener sub ubicaciones",
                "is_used_in_physical_inventory": "tiene inventarios físicos asociados y no puede tener sub ubicaciones"
              }
            }
          },
          "location_product": {
            "attributes": {
              "location_id": {
                "taken": "ya existe, esto quiere decir que este producto ya ha sido agregado anteriormente"
              },
              "max_inventory": {
                "invalid_value": "debe ser mayor al mínimo"
              },
              "reorder_point": {
                "greater_than_max_inventory": "debe ser menor al máximo",
                "less_than_min_inventory": "debe ser mayor al mínimo"
              }
            }
          },
          "physical_inventory": {
            "attributes": {
              "date": {
                "less_than_physical_inventory_applied": "es menor a un inventario físico aplicado"
              },
              "items": {
                "blank": "Debe tener al menos un producto"
              },
              "location_id": {
                "pending_physical_inventory": "tiene un inventario físico sin aplicar"
              }
            }
          },
          "product": {
            "attributes": {
              "cabys_code": {
                "not_service": "No puede ser un servicio",
                "service": "Debe ser un servicio"
              },
              "unit_of_measure": {
                "used_in_documents": "tiene documentos asociados y no puede ser modificada"
              }
            }
          },
          "return_item": {
            "attributes": {
              "reference_document_line_id": {
                "taken": "ya ha sido devuelto anteriormente"
              }
            }
          }
        }
      },
      "models": {
        "account": {
          "one": "Cuenta",
          "other": "Cuentas"
        },
        "account_user": {
          "one": "Usuario",
          "other": "Usuarios"
        },
        "credit_note": {
          "one": "Devolución",
          "other": "Devoluciones"
        },
        "customer": {
          "one": "Cliente",
          "other": "Clientes"
        },
        "customer_category": {
          "one": "Categoría",
          "other": "Categorías"
        },
        "exoneration": {
          "one": "Exoneración",
          "other": "Exoneraciones"
        },
        "factura_electronica/setting": "Factura electrónica",
        "inventory_adjustment": {
          "one": "Ajuste de inventario",
          "other": "Ajustes de inventario"
        },
        "location": {
          "one": "Ubicación",
          "other": "Ubicaciones"
        },
        "paper_trail/version": {
          "one": "Bitácora",
          "other": "Bitácora"
        },
        "physical_inventory": {
          "one": "Inventario Físico",
          "other": "Inventarios Físicos"
        },
        "pricing_list": {
          "one": "Lista de precios",
          "other": "Listas de precios"
        },
        "pricing_list_product": {
          "one": "Precio de Producto",
          "other": "Precio de Productos"
        },
        "pricing_list_product/fixed": {
          "one": "Fijo",
          "other": "Fijo"
        },
        "pricing_list_product/percentage": {
          "one": "Porcentaje",
          "other": "Porcentajes"
        },
        "pricing_plan": {
          "one": "Plan",
          "other": "Planes"
        },
        "product": {
          "one": "Producto",
          "other": "Productos"
        },
        "product_category": {
          "one": "Categoría",
          "other": "Categorías"
        },
        "purchase_order": {
          "one": "Orden de Compra",
          "other": "Órdenes de Compra"
        },
        "return_item": {
          "one": "Ítem",
          "other": "Itemes"
        },
        "role": {
          "one": "Rol",
          "other": "Roles"
        },
        "sales_order": {
          "one": "Orden de Venta",
          "other": "Órdenes de Venta"
        },
        "user": {
          "one": "Usuario",
          "other": "Usuarios"
        },
        "vendor": {
          "one": "Proveedor",
          "other": "Proveedores"
        }
      }
    },
    "admin": {
      "account_users": {
        "form": {
          "user_id": "Usuario"
        }
      },
      "accounts": {
        "account": {
          "no_logo_attached": "Sin logo"
        },
        "form": {
          "color_themes": {
            "names": {
              "amber": "Amber",
              "blue": "Azul",
              "cyan": "Cian",
              "emerald": "Esmeralda",
              "fuchsia": "Fucsia",
              "green": "Verde",
              "indigo": "Indigo",
              "lime": "Lima",
              "orange": "Anaranjado",
              "pink": "Rosado",
              "purple": "Púrpura",
              "red": "Rojo",
              "rose": "Rosa",
              "sky": "Cielo",
              "teal": "Verde azulado",
              "violet": "Violeta",
              "yellow": "Amarillo"
            }
          }
        }
      },
      "dashboard": {
        "show": {
          "online_users": "Usuarios en Línea",
          "total_accounts": "Total de Cuentas",
          "total_users": "Total de Usuarios"
        }
      },
      "users": {
        "accounts_by_user": {
          "accounts": {
            "account_id": "Cuenta",
            "role_id": "Rol"
          },
          "title": "Cuentas asignadas al usuario"
        },
        "new": {
          "title": "Usuarios"
        },
        "show": {
          "title": "Usuarios"
        },
        "user": {
          "admin": {
            "false": false,
            "true": "Si"
          },
          "administrator": "Administrador",
          "created_at": "Fecha de creación",
          "email": "Correo electrónico",
          "full_name": "Nombre Completo",
          "last_sign_in_at": "Fecha de último ingreso"
        }
      }
    },
    "autocomplete": {
      "no_results": "No se encontraron resultados para \"%{text}\"."
    },
    "breadcrumb": {
      "root": "Inicio"
    },
    "buttons": {
      "filters": "Filtros",
      "home": "Inicio",
      "new": "Nuevo",
      "settings": "Parámetros"
    },
    "certificates_sanity_check_mailer": {
      "expired": {
        "hidden_intro": "La llave criptográfica para %{account_name} caducó hace %{days}",
        "message": "¡Estimado %{user_name}!<br />\n<br />\nEsta es una notificación automática generada por Numeros.cr para\ninformarle que la llave criptográfica que tenemos en nuestro sistema\npara <b>%{account_name}</b> caducó hace %{days} por lo que es necesario\ngenerar y/o cargar una nueva. Hasta que no se realice esta renovación no\nse podrán generar ni confirmar nuevos documentos electrónicos.<br />\n<br />\n<h3 style=\"font-family: sans-serif; font-size: 16px;margin:10px 0;\">\n¿Por qué caducó mi llave?\n</h3>\nPor dispocición del Ministerio de Hacienda las llaves tienen una vigencia\nde 2 años.\n<h3 style=\"font-family: sans-serif; font-size: 16px;margin:10px 0;\">\n¿Qué tengo que hacer para renovarla?\n</h3>\nAfortunadamente la renovación de la llave criptográfica es un proceso\nsencillo, podés hacerlo siguiendo estos pasos:\n<ol>\n  <li>Ingresá al portal de Hacienda a esta dirección:\n    <a href=\"https://www.hacienda.go.cr/ATV/Login.aspx\">https://www.hacienda.go.cr/ATV/Login.aspx</a>\n  </li>\n  <li>\n    Revoque su llave criptográfica de producción: En el menú superior hacé click en\n    \"Comprobantes Electrónicos\" > \"Llave Criptográfica de Producción\" >\n    \"Revocar llave criptográfica en produc.\"\n  </li>\n  <li>\n    Generá una nueva llave criptográfica de producción: En el menú superior\n    hacé click en \"Comprobantes Electrónicos\" > \"Llave Criptográfica de Producción\" >\n    \"Generar llave criptográfica en produc.\"\n  </li>\n  <li>\n    Descargá la llave generada, recuerde el PIN utilizado para gerarla pues será\n    necesario indicarlo en el siguiente paso\n  </li>\n  <li>\n    Subí la nueva llave a Numeros.cr en <a href=\"%{upload_url}\">%{upload_url}</a>\n  </li>\n</ol>\n<p>\n  ¡Saludos!<br/>\n  Equipo de <a href=\"https://numeros.cr\">Numeros.cr</a>\n</p>\n<br />\n",
        "subject": "[Acción Requerida] Llave criptográfica ha caducado",
        "title": "Llave criptográfica ha caducado"
      },
      "expires_soon": {
        "hidden_intro": "La llave criptográfica para %{account_name} caducará en %{days}",
        "message": "¡Estimado %{user_name}!<br />\n<br />\nEsta es una notificación automática generada por Numeros.cr para\ninformarle que la llave criptográfica que tenemos en nuestro sistema\npara <b>%{account_name}</b> caducará en %{days} por lo que es necesario\ngenerar y/o cargar una nueva. Si la llave no se actualiza no\nse podrán generar ni confirmar nuevos documentos electrónicos\nuna vez caducada.<br />\n<br />\n<h3 style=\"font-family: sans-serif; font-size: 16px;margin:10px 0;\">\n¿Por qué caducan las llaves?\n</h3>\nPor dispocición del Ministerio de Hacienda las llaves tienen una vigencia\nde 2 años.\n<h3 style=\"font-family: sans-serif; font-size: 16px;margin:10px 0;\">\n¿Qué tengo que hacer para renovarla?\n</h3>\nAfortunadamente la renovación de la llave criptográfica es un proceso\nsencillo, podés hacerlo siguiendo estos pasos:\n<ol>\n  <li>Ingresá al portal de Hacienda a esta dirección:\n    <a href=\"https://www.hacienda.go.cr/ATV/Login.aspx\">https://www.hacienda.go.cr/ATV/Login.aspx</a>\n  </li>\n  <li>\n    Revoque su llave criptográfica de producción: En el menú superior hacé click en\n    \"Comprobantes Electrónicos\" > \"Llave Criptográfica de Producción\" >\n    \"Revocar llave criptográfica en produc.\"\n  </li>\n  <li>\n    Generá una nueva llave criptográfica de producción: En el menú superior\n    hacé click en \"Comprobantes Electrónicos\" > \"Llave Criptográfica de Producción\" >\n    \"Generar llave criptográfica en produc.\"\n  </li>\n  <li>\n    Descargá la llave generada, recuerde el PIN utilizado para gerarla pues será\n    necesario indicarlo en el siguiente paso\n  </li>\n  <li>\n    Subí la nueva llave a Numeros.cr en <a href=\"%{upload_url}\">%{upload_url}</a>\n  </li>\n</ol>\n<p>\n  ¡Saludos!<br/>\n  Equipo de <a href=\"https://numeros.cr\">Numeros.cr</a>\n</p>\n<br />\n",
        "subject": "[Acción Requerida] Llave criptográfica caducará pronto",
        "title": "Llave criptográfica caducará pronto"
      },
      "invalid": {
        "hidden_intro": "La llave criptográfica para %{account_name} no es válida",
        "message": "¡Estimado %{user_name}!<br />\n<br />\nEsta es una notificación automática generada por Numeros.cr para\ninformarle que la llave criptográfica que tenemos en nuestro sistema\npara <b>%{account_name}</b> no es válida por lo que es necesario generar\ny/o cargar una nueva para así evitar problemas durante la facturación.<br />\n<br />\n",
        "subject": "[Acción Requerida] Llave criptográfica no es válida",
        "title": "Llave criptográfica inválida"
      }
    },
    "contact_message_mailer": {
      "new_message": {
        "subject": "Nuevo mensaje de contacto"
      }
    },
    "data_copy": {
      "suffix": "copia"
    },
    "data_exports": {
      "documents": {
        "headers": {
          "consecutive": "Consecutivo",
          "currency": "Moneda",
          "date": "Fecha",
          "discount": "Descuento",
          "document_type": "Tipo de documento",
          "due": "Monto pendiente",
          "exchange_rate": "Tipo de cambio",
          "net_total": "Subtotal neto",
          "paid": "Monto cancelado",
          "receiver_identification": "Identificación del Receptor",
          "receiver_name": "Receptor",
          "status": "Estado",
          "subtotal": "Subtotal",
          "taxes": "Impuestos",
          "total": "Total"
        }
      }
    },
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "default": "%d/%m/%Y",
        "document_pdf": "%d de %B de %Y",
        "long": "%A, %d de %B de %Y",
        "short": "%d de %b",
        "xlsx": "%d/%m/%Y"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datepicker": {
      "clear": "Limpiar",
      "date_format": "dd/mm/yyyy",
      "datetime_format": "dd/mm/yyyy, hh:mm",
      "month_format": "mm/yyyy",
      "parse_format": "%d/%m/%Y",
      "title_format": "MM y",
      "today": "Hoy"
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "cerca de %{count} hora",
          "other": "cerca de %{count} horas"
        },
        "about_x_months": {
          "one": "cerca de %{count} mes",
          "other": "cerca de %{count} meses"
        },
        "about_x_years": {
          "one": "cerca de %{count} año",
          "other": "cerca de %{count} años"
        },
        "almost_x_years": {
          "one": "casi %{count} año",
          "other": "casi %{count} años"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de %{count} minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de %{count} segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de %{count} año",
          "other": "más de %{count} años"
        },
        "x_days": {
          "one": "%{count} día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "%{count} minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "%{count} mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "%{count} segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "%{count} año",
          "other": "%{count} años"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mes",
        "second": "Segundo",
        "year": "Año"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Tu cuenta ha sido confirmada satisfactoriamente.",
        "new": {
          "resend_confirmation_instructions": "Reenviar instrucciones de confirmación"
        },
        "send_instructions": "Vas a recibir un correo con instrucciones sobre cómo confirmar tu cuenta en unos minutos.",
        "send_paranoid_instructions": "Si tu correo existe en nuestra base de datos, en unos minutos recibirás un correo con instrucciones sobre cómo confirmar tu cuenta."
      },
      "failure": {
        "already_authenticated": "Ya has iniciado sesión.",
        "inactive": "Tu cuenta aún no ha sido activada.",
        "invalid": "%{authentication_keys} o contraseña inválidos.",
        "last_attempt": "Tienes un intento más antes de que tu cuenta sea bloqueada.",
        "locked": "Tu cuenta está bloqueada.",
        "not_found_in_database": "%{authentication_keys} o contraseña inválidos.",
        "timeout": "Tu sesión expiró. Por favor, inicia sesión nuevamente para continuar.",
        "unauthenticated": "Tienes que iniciar sesión o registrarte para poder continuar.",
        "unconfirmed": "Tienes que confirmar tu cuenta para poder continuar."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmar mi cuenta",
          "greeting": "¡Bienvenido %{recipient}!",
          "instruction": "Usted puede confirmar el correo electrónico de su cuenta a través de este enlace:",
          "subject": "Instrucciones de confirmación"
        },
        "email_changed": {
          "greeting": "¡Hola %{recipient}! ",
          "message": "Estamos contactando contigo para notificarte que tu email ha sido cambiado a %{email}.",
          "subject": "Email cambiado"
        },
        "password_change": {
          "greeting": "Hola %{recipient}!",
          "message": "Le estamos contactando para notificarle que su contraseña ha sido cambiada.",
          "subject": "Contraseña cambiada"
        },
        "reset_password_instructions": {
          "action": "Cambiar mi contraseña",
          "greeting": "¡Hola %{recipient}!",
          "instruction": "Alguien ha solicitado un enlace para cambiar tu contraseña, lo que se podés hacer a través del siguiente enlace.",
          "instruction_2": "Si vos no lo has solicitado, podés ignorar este este correo electrónico.",
          "instruction_3": "Tu contraseña no será cambiada hasta que accedás al enlace y creés una nueva.",
          "subject": "Instrucciones de recuperación de contraseña"
        },
        "unlock_instructions": {
          "action": "Desbloquear mi cuenta",
          "greeting": "¡Hola %{recipient}!",
          "instruction": "Haga click en el siguiente enlace para desbloquear su cuenta:",
          "message": "Su cuenta ha sido bloqueada debido a una cantidad excesiva de intentos infructuosos para ingresar.",
          "subject": "Instrucciones para desbloquear"
        }
      },
      "omniauth_callbacks": {
        "failure": "No has sido autorizado en la cuenta %{kind} porque \"%{reason}\".",
        "success": "Has sido autorizado satisfactoriamente en la cuenta %{kind}."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Cambiar mi contraseña",
          "change_your_password": "Cambie su contraseña",
          "confirm_new_password": "Confirme la nueva contraseña",
          "new_password": "Nueva contraseña",
          "submit_button": "Cambiar contraseña",
          "title": "Cambiar mi contraseña"
        },
        "new": {
          "forgot_your_password": "¿Ha olvidado su contraseña?",
          "send_me_reset_password_instructions": "Envíeme las instrucciones para resetear mi contraseña",
          "submit_button": "Enviar",
          "title": "Recuperación de contraseña"
        },
        "no_token": "No puedes acceder a esta página si no es a través de un enlace para resetear tu contraseña. Si has llegado hasta aquí desde el email para resetear tu contraseña, por favor asegúrate de que la URL introducida está completa.",
        "send_instructions": "Recibirás un correo con instrucciones sobre cómo resetear tu contraseña en unos pocos minutos.",
        "send_paranoid_instructions": "Si tu correo existe en nuestra base de datos, recibirás un correo con instrucciones sobre cómo resetear tu contraseña en tu bandeja de entrada.",
        "updated": "Se ha cambiado tu contraseña. Ya iniciaste sesión.",
        "updated_not_active": "Tu contraseña fue cambiada."
      },
      "registrations": {
        "destroyed": "¡Adiós! Tu cuenta ha sido cancelada correctamente. Esperamos verte pronto.",
        "edit": {
          "are_you_sure": "¿Está usted seguro?",
          "cancel_my_account": "Anular mi cuenta",
          "currently_waiting_confirmation_for_email": "Actualmente esperando la confirmacion de: %{email} ",
          "leave_blank_if_you_don_t_want_to_change_it": "dejar en blanco si no desea cambiarla",
          "title": "Editar %{resource}",
          "unhappy": "¿Disconforme?",
          "update": "Actualizar",
          "we_need_your_current_password_to_confirm_your_changes": "necesitamos su contraseña actual para confirmar los cambios"
        },
        "new": {
          "sign_up": "Registrarse"
        },
        "signed_up": "Bienvenido. Tu cuenta fue creada.",
        "signed_up_but_inactive": "Tu cuenta ha sido creada correctamente. Sin embargo, no hemos podido iniciar la sesión porque tu cuenta aún no está activada.",
        "signed_up_but_locked": "Tu cuenta ha sido creada correctamente. Sin embargo, no hemos podido iniciar la sesión porque que tu cuenta está bloqueada.",
        "signed_up_but_unconfirmed": "Se ha enviado un mensaje con un enlace de confirmación a tu correo electrónico. Abre el enlace para activar tu cuenta.",
        "update_needs_confirmation": "Has actualizado tu cuenta correctamente, pero es necesario confirmar tu nuevo correo electrónico. Por favor, comprueba tu correo y sigue el enlace de confirmación para finalizar la comprobación del nuevo correo electrónico.",
        "updated": "Tu cuenta se ha actualizado.",
        "updated_but_not_signed_in": "Su cuenta se ha actualizado correctamente, pero como se cambió su contraseña, debe iniciar sesión nuevamente"
      },
      "sessions": {
        "already_signed_out": "Sesión finalizada.",
        "new": {
          "login": "Iniciar sesión",
          "sign_in": "Iniciar sesión",
          "title": "Iniciar sesión"
        },
        "signed_in": "Sesión iniciada.",
        "signed_out": "Sesión finalizada."
      },
      "shared": {
        "links": {
          "back": "Atrás",
          "didn_t_receive_confirmation_instructions": "¿No ha recibido las instrucciones de confirmación?",
          "didn_t_receive_unlock_instructions": "¿No ha recibido instrucciones para desbloquear?",
          "didnt_receive_confirmation_instructions": "¿No recibiste las instrucciones para confirmar tu cuenta?",
          "didnt_receive_unlock_instructions": "¿No recibiste las instrucciones para desbloquear tu cuenta?",
          "dont_have_an_account": "¿No tenés una cuenta?",
          "forgot_password": "¿Olvidaste tu contraseña?",
          "forgot_your_password": "¿Ha olvidado su contraseña?",
          "login": "Iniciar sesión",
          "login_with": "Iniciar sesión con %{provider}",
          "sign_in": "Iniciar sesión",
          "sign_in_with_provider": "Iniciar sesión con %{provider}",
          "sign_up": "Registrarse",
          "signup": "Registrate"
        },
        "minimum_password_length": {
          "one": "(%{count} caractere como mínimo)",
          "other": "(%{count} caracteres como mínimo)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Reenviar instrucciones para desbloquear"
        },
        "send_instructions": "Vas a recibir instrucciones para desbloquear tu cuenta en unos pocos minutos.",
        "send_paranoid_instructions": "Si tu cuenta existe, vas a recibir instrucciones para desbloquear tu cuenta en unos pocos minutos.",
        "unlocked": "Tu cuenta ha sido desbloqueada. Ya puedes iniciar sesión."
      }
    },
    "document": {
      "invoice_to": "Factura a",
      "payment_to": "Pago a"
    },
    "document_history_item": {
      "canceled": "Este documento fue anulado",
      "created": "Este documento fue creado",
      "factura_electronica/aceptado": "Este documento fue aceptado por Hacienda",
      "factura_electronica/rechazado": "Este documento fue rechazado por Hacienda",
      "payment_created": "Se registró un pago por %{amount}",
      "sent": "Este documento fue enviado",
      "viewed": "Este documento fue visto"
    },
    "document_mailer": {
      "accepted": {
        "hidden_intro": "Nueva factura de %{sender} por %{amount} - %{document_number}",
        "intro": "Has recibido una nueva factura de <b>%{sender}</b>",
        "subject": "[%{account_name}] Factura %{document_number}"
      },
      "factura_electronica": {
        "document_confirmation_mailer": {
          "new_confirmation": {
            "hidden_intro": {
              "1": "Hemos ACEPTADO tu %{document_type} #%{consecutive} por %{amount}",
              "2": "Hemos ACEPTADO PARCIALMENTE tu %{document_type} #%{consecutive} por %{amount}",
              "3": "Hemos RECHAZADO tu %{document_type} #%{consecutive} por %{amount}"
            },
            "intro": {
              "1": "La %{document_type} #%{consecutive} por %{amount} que nos has enviado ha sido ACEPTADA correctamente",
              "2": "La %{document_type} #%{consecutive} por %{amount} que nos has enviado ha sido ACEPTADA PARCIALMENTE",
              "3": "La %{document_type} #%{consecutive} por %{amount} que nos has enviado ha sido RECHAZADA"
            },
            "subject": "[%{account_name}] Confirmación de documento electrónico #%{consecutive}"
          }
        }
      }
    },
    "documents": {
      "show": {
        "discount": "Descuento",
        "document_number": "Factura",
        "document_to": "Cliente",
        "factura_electronica": {
          "consecutive": "Consecutivo",
          "currency": "Moneda",
          "date": "Fecha",
          "document_number": "Factura",
          "document_types": {
            "1": "Factura Electrónica",
            "2": "Nota de débito",
            "3": "Nota de crédito",
            "4": "Tiquete Electrónico",
            "8": "Factura Electrónica de Compra",
            "9": "Factura Electrónica de Exportación"
          },
          "due_at": "Vence",
          "exchange_rate": "Tipo de cambio",
          "key": "Clave"
        },
        "items": {
          "code": "Código",
          "item": "Item",
          "price": "Precio",
          "quantity": "Cantidad",
          "title": "Item",
          "total": "Total"
        },
        "page_number": "Página %{page} de %{count}",
        "subtotal": "Subtotal",
        "taxes": "Impuesto",
        "total": "Total"
      }
    },
    "doorkeeper": {
      "scopes": {
        "accounts_info": "Información básica de tus cuentas en Numeros.cr",
        "document_confirm": "Confirmar documentos electrónicos."
      }
    },
    "downloads": {
      "filenames": {
        "csv": {
          "accounts": "Cuentas-%{suffix}.csv",
          "activity_logs": "Bitácora-%{suffix}.csv",
          "physical_inventories": "Inventario-Físico-%{suffix}.csv",
          "pricing_plans": "Planes-%{suffix}.csv",
          "users": "Usuarios-%{suffix}.csv"
        }
      }
    },
    "error": {
      "not_access": {
        "message_with_subdomain": "La cuenta a la que has intentado ingresar no existe o no te han dado acceso, podés intentar con alguna de las siguientes cuentas o iniciar sesión con otro usuario:",
        "message_without_subdomain": "La cuenta a la que has intentado ingresar no existe o no te han dado acceso, podés intentar inicianado sesión con otro usuario",
        "title": "Ha habido un error..."
      }
    },
    "errors": {
      "document_confirmations": {
        "emails_cannot_be_blank": "Es necesario indicar los correos electrónicos a quienes enviar el correo."
      },
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado",
        "already_confirmed": "ya ha sido confirmada, por favor intenta iniciar sesión",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "confirmation_period_expired": "necesita confirmarse dentro de %{period}, por favor solicita una nueva",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "even": "debe ser un número par",
        "exclusion": "está reservado",
        "expired": "ha expirado, por favor solicita una nueva",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor o igual que %{count}",
        "in": "debe estar en %{count}",
        "inclusion": "no está incluido en la lista",
        "invalid": "es inválido",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor o igual que %{count}",
        "model_invalid": "La validación falló: %{errors}",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "not_found": "no se ha encontrado",
        "not_locked": "no estaba bloqueada",
        "not_saved": {
          "one": "Ocurrió un error al tratar de guardar %{resource}:",
          "other": "Ocurrieron %{count} errores al tratar de guardar %{resource}:"
        },
        "odd": "debe ser un número impar",
        "other_than": "debe ser distinto de %{count}",
        "present": "debe estar en blanco",
        "required": "debe existir",
        "taken": "ya ha sido utilizado",
        "too_long": {
          "one": "es demasiado largo (máximo %{count} carácter)",
          "other": "es demasiado largo (máximo %{count} caracteres)"
        },
        "too_short": {
          "one": "es demasiado corto (mínimo %{count} carácter)",
          "other": "es demasiado corto (mínimo %{count} caracteres)"
        },
        "wrong_length": {
          "one": "longitud errónea (debe ser de %{count} carácter)",
          "other": "longitud errónea (debe ser de %{count} caracteres)"
        }
      },
      "template": {
        "body": "Revise que los siguientes campos sean válidos:",
        "header": {
          "one": "%{model} no pudo guardarse debido a %{count} error",
          "other": "%{model} no pudo guardarse debido a %{count} errores"
        }
      }
    },
    "filters": {
      "enum": {
        "activated_in": {
          "false": "Inactivo",
          "true": "Activo"
        },
        "date_range_between": {
          "30_days": "Últ. 30 días",
          "60_days": "Últ. 60 días",
          "90_days": "Últ. 90 días",
          "custom": "Personalizado"
        }
      },
      "labels": {
        "activated_in": "Activo/Inactivo",
        "all": "Todos",
        "inventory_adjustment": {
          "date_time_between": "Fecha Ajuste"
        },
        "product": {
          "barcode_cont": "Cod. Barras"
        },
        "purchase_order": {
          "date_time_between": "Fecha Orden"
        },
        "sales_order": {
          "date_time_between": "Fecha Orden"
        },
        "show": "Mostrar",
        "status_in": "Estado"
      },
      "values": {
        "date_range": "De %{from} a %{to}"
      }
    },
    "frontend": {
      "account_settings": {
        "customer_categories": {
          "content": {
            "add_new_customer_category": "Agregar categoría"
          },
          "customer_categories": {
            "add_new_customer_category": "Agregar categoría"
          },
          "form": {
            "name": "Nombre de la categoría"
          },
          "index": {
            "header": "Categorías de clientes"
          }
        },
        "general_cost_type": {
          "description_1": "Elija el tipo de costo a utilizar para el manejo del inventario",
          "header": "Tipo de costo1"
        },
        "general_currencies": {
          "description_1": "Elija las monedas con las cuáles manejar el inventario",
          "description_base_currency": "Elija la moneda base para el tipo de cambio",
          "header": "Monedas"
        },
        "general_custom_fields": {
          "custom_text": "Etiqueta personalizada",
          "default_text": "Etiqueta actual",
          "description_1": "Elija el texto que desea mostrar en las etiquetas",
          "header": "Renombrar etiquetas"
        },
        "general_logo": {
          "description_1": "Elija o cambie el logo de la empresa",
          "header": "Logo de la empresa"
        },
        "general_regional": {
          "description_1": "Especifica la configuración regional para el manejo de los números.",
          "description_2": "Deje el valor en blanco para usar la configuración regional del sistema",
          "header": "Configuración regional"
        },
        "inventory_list_view": {
          "description_1": "Elija si los artículos deben mostrar el (SKU) o la descripción en la lista y los documentos",
          "description_2": "SKU son códigos únicos que identifican un producto, y la descripción generalmente se usa para brindar detalle del artículo",
          "description_3": "Siempre puede editar el nombre del producto, el SKU y la descripción desde la página del producto",
          "header": "SKU o Descripción"
        },
        "inventory_units_of_measure": {
          "description_1": "Elija las unidades de medida que serán utilizadas para asignarlas a los artículos",
          "header": "Unidades de medida",
          "search_input": "Buscar unidad de medida"
        },
        "locations": {
          "content": {
            "add_new_location": "Agregar ubicación",
            "assigned_location": "Ubicación asignada a una orden, no puede tener sububicaciones"
          },
          "edit": {
            "locations": "Ubicaciones"
          },
          "form": {
            "code": "Cód.",
            "name": "Nombre"
          },
          "index": {
            "created_at": "Creado en",
            "header": "Ubicaciones",
            "location": "Ubicación",
            "parent": "Ubicación Padre"
          },
          "location": {
            "allow_customer_returns": "Permitir Devoluciones de Clientes",
            "allow_purchases": "Permitir Compras",
            "allow_sales": "Permitir Ventas",
            "code": "Código",
            "name": "Nombre",
            "parent_id": "Ubicación Padre"
          },
          "locations": {
            "add_new_location": "Agregar ubicación"
          },
          "new": {
            "locations": "Ubicaciones",
            "title": "Nueva ubicación"
          },
          "show": {
            "locations": "Ubicaciones",
            "settings": "Parámetros"
          }
        },
        "product_categories": {
          "content": {
            "add_new_product_category": "Agregar categoría"
          },
          "form": {
            "name": "Nombre de la categoría"
          },
          "index": {
            "header": "Categorías de artículos"
          },
          "product_categories": {
            "add_new_product_category": "Agregar categoría"
          }
        }
      },
      "account_users": {
        "account_user": {
          "created_at": "Creado en",
          "email": "Correo electrónico",
          "full_name": "Nombre Completo",
          "last_sign_in_at": "Fecha del último ingreso",
          "location_ids": "Ubicaciones",
          "role_id": "Rol",
          "vendor_code": "Código de vendedor"
        },
        "edit": {
          "title": "Usuarios"
        },
        "index": {
          "full_name": "Nombre Completo",
          "title": "Usuarios"
        },
        "new": {
          "title": "Usuarios"
        },
        "show": {
          "title": "Usuarios"
        }
      },
      "customers": {
        "contact_form": {
          "address": "Dirección",
          "identifier_type": "Tipo de Identificación"
        },
        "form": {
          "bank_accounts": "Cuentas Bancarias",
          "billing_contact": "Contacto de Facturación",
          "cabys_codes": "Códigos Cabys (%{count})",
          "exonerations": "Exoneraciones",
          "main_contact": "Contacto Principal",
          "secondary_contacts": "Otros Contactos",
          "use_main_contact_for_billing": "Utilizar estos datos para facturación"
        }
      },
      "inventory_adjustments": null,
      "physical_inventories": {
        "edit": {
          "title": "Inventarios Físicos"
        },
        "form": {
          "apply_physical_inventory": "Aplicar inventario físico"
        },
        "index": {
          "go_to_inventory_adjustment": "Ver ajuste del inventario físico",
          "location_name": "Ubicación"
        },
        "inventory_adjustments": {
          "inventory_adjustment": {
            "go_back_physical_inventories": "Regresar lista de inventarios físicos",
            "go_back_physical_inventory": "Volver al inventario físico",
            "location_id": "Ubicación",
            "message_error": "No fue posible aplicar el inventario físico. Favor corregir los errores y vuelva a intentarlo.",
            "physical_inventory_date": "Fecha del inventario físico"
          },
          "inventory_adjustment_items": {
            "adjustment": "Ajuste",
            "code": "Código del producto",
            "cost": "Costo",
            "description": "Descripción",
            "physical_balance": "Cantidad inventario físico",
            "system_balance": "Cantidad en el sistema",
            "title": "Items del ajuste del inventario físico"
          },
          "new": {
            "apply_physical_inventory": "Aplicar inventario físico",
            "title": "Nuevo ajuste de inventario físico"
          }
        },
        "new": {
          "title": "Inventarios Físicos"
        },
        "physical_inventory": {
          "date": "Fecha",
          "inventory_status": "Estado",
          "location_id": "Ubicación"
        },
        "physical_inventory_items": {
          "code": "Código del producto",
          "description": "Descripción",
          "quantity": "Cantidad",
          "title": "Items de la toma física",
          "unit_of_measure": "Unidad de medida"
        },
        "show": {
          "title": "Inventarios Físicos"
        }
      },
      "pricing_list_products": {
        "no_products": {
          "all_products_already_in_list": "No hay productos que no se hayan agregado ya a la lista de precios actual",
          "search_with_no_results": "No hay resultados para la búsqueda"
        },
        "products": {
          "add_button": "Agregar",
          "search_for_product": "Buscar productos...",
          "title": "Agregá productos a la lista"
        }
      },
      "pricing_lists": {
        "form": {
          "add_products": "Agregar productos"
        }
      },
      "products": {
        "equivalencies": {
          "form": {
            "base_quantity": "Unidad de medida",
            "equivalency": "Equivalencia"
          }
        },
        "form": {
          "add_equivalency": "Agregar equivalencia",
          "stock_settings": "Niveles de stock y punto de reorden",
          "tooltip_content": "Administre su inventario basado en diferentes unidades de medida",
          "units_of_measure": {
            "standar": "Unidad de medida estándar"
          }
        },
        "imports": {
          "form": {
            "columns_description": "Seleccione la columna correspondiente a cada campo",
            "configure_import": "Configure la importación",
            "download": "Descargue archivo de errores",
            "error": {
              "exists": "Este producto ya ha sido agregado anteriormente"
            },
            "error_rows": "Errores:",
            "fields": {
              "cabys_code": "Código CABYS",
              "code": "Código",
              "description": "Descripción",
              "iva_code": "Código IVA",
              "quantity": "Cantidad",
              "unit_of_measure": "Unidad de medida"
            },
            "file_name": "Nombre de archivo",
            "header": "Importar Productos",
            "headers": "¿El archivo contiene la fila de encabezados?",
            "imported_rows": "Importados:",
            "select_file": "Seleccione un archivo csv",
            "step": "Paso %{step}: ",
            "total_rows": "Total:",
            "with_header": "Sí",
            "without_header": "No"
          }
        },
        "location_products": {
          "form": {
            "max_inventory": "Máximo",
            "min_inventory": "Mínimo",
            "reorder_point": "Punto de reorden",
            "title": "Ubicación"
          }
        },
        "locations": {
          "location": "Ubicación",
          "location_cost": "Costo",
          "location_name": "Ubicación",
          "location_quantity": "Cantidad",
          "quantity": "Cantidad",
          "title": "Cantidad disponible"
        },
        "measurements": {
          "measurements": "Medidas"
        }
      },
      "profiles": {
        "form": {
          "login": {
            "last_sign_in_at": "Ultimo ingreso",
            "sign_in_count": "Número de ingresos",
            "title": "Información de ingreso"
          }
        }
      },
      "purchase_orders": {
        "form": {
          "tabs": {
            "purchase": "Orden",
            "receive": "Recepción"
          }
        },
        "receive_tab_content": {
          "auto_fill": "Auto completar"
        }
      },
      "purchases": {
        "purchase": {
          "received_at": "Recibido en"
        }
      },
      "reports": {
        "d104": {
          "activity_id": "Actividad",
          "amount": "Monto",
          "d104_report": "D104 Impuestos al valor agregado",
          "date": "Fecha",
          "exempt_expenses_total": "Compras sin IVA soportado y/o con IVA soportado no acreditable",
          "exempt_purchases": {
            "import": {
              "goods": "Importación de bienes",
              "services": "Importación de servicios"
            },
            "local": {
              "goods": "Compra local de bienes",
              "services": "Compra local de servicios"
            }
          },
          "exempt_sales_total": "Ventas exentas (Art.8)",
          "id": "Cédula",
          "items_types": {
            "goods": "Bienes",
            "services": "Servicios"
          },
          "period": "Periodo",
          "purchases_title": "Compras del periodo",
          "purchases_total": "Total de compras",
          "rates": {
            "rate_02": "Bienes y servicios afectos al 1%",
            "rate_03": "Bienes y servicios afectos al 2%",
            "rate_04": "Bienes y servicios afectos al 4%",
            "rate_07": "Bienes y servicios afectos al 8%",
            "rate_08": "Bienes y servicios afectos al 13%"
          },
          "report_name": "Reporte D104",
          "sales_exempt": {
            "export": {
              "goods": "Exportación de bienes",
              "services": "Exportación de servicios"
            },
            "local": {
              "goods": "Venta local de bienes",
              "services": "Venta local de servicios"
            }
          },
          "sales_title": "Ventas del periodo",
          "sales_total": "Total de ventas sujetas, exentas y no sujetas",
          "taxed_sales_total": "Ventas sujetas (Base Imponible)"
        },
        "edit": {
          "reports": "Reportes",
          "root": "Inicio",
          "title": "Impuestos al valor agregado"
        },
        "forms": {
          "d104": {
            "activity_id": "Actividad",
            "factura_electronica_activity": "Actividad",
            "period": "Periodo"
          },
          "purchases": {
            "activity_id": "Actividad",
            "currency": "Moneda",
            "end_date": "Fecha final",
            "factura_electronica_activity": "Actividad",
            "start_date": "Fecha inicial"
          },
          "purchases_with_lines": {
            "activity_id": "Actividad",
            "currency": "Moneda",
            "end_date": "Fecha final",
            "factura_electronica_activity": "Actividad",
            "start_date": "Fecha inicial"
          },
          "sales": {
            "activity_id": "Actividad",
            "currency": "Moneda",
            "end_date": "Fecha final",
            "factura_electronica_activity": "Actividad",
            "start_date": "Fecha inicial"
          },
          "sales_with_lines": {
            "activity_id": "Actividad",
            "currency": "Moneda",
            "end_date": "Fecha final",
            "factura_electronica_activity": "Actividad",
            "start_date": "Fecha inicial"
          }
        },
        "index": {
          "options": {
            "d104": "Impuestos al valor agregado (D104)",
            "purchases": "Compras",
            "purchases_with_lines": "Compras con detalle de líneas",
            "sales": "Ventas",
            "sales_with_lines": "Ventas con detalle de líneas"
          },
          "root": "Inicio",
          "title": "Reportes"
        },
        "purchases": {
          "activity_id": "Actividad",
          "columns": {
            "date": "Fecha",
            "discount": "Descuento",
            "exchange_rate": "Tipo de cambio",
            "iva": "IVA",
            "number": "Número de factura",
            "product_code": "Código de producto",
            "product_name": "Nombre del producto",
            "quantity": "Cantidad",
            "subtotal": "Subtotal",
            "supplier": "Proveedor",
            "total": "Total",
            "unit_cost": "Costo unitario",
            "unit_of_measurement": "Unidad de medida"
          },
          "currency": "Moneda",
          "date": "Fecha",
          "id": "Cédula",
          "period": "Periodo",
          "purchases_with_lines_report": "Compras con detalle de líneas",
          "range": "Desde %{from} hasta %{to}",
          "report_name": "Reporte Compras",
          "summary_purchases_report": "Compras"
        },
        "sales": {
          "activity_id": "Actividad",
          "columns": {
            "client": "Cliente",
            "date": "Fecha",
            "discount": "Descuento",
            "exchange_rate": "Tipo de cambio",
            "iva": "IVA",
            "number": "Número de factura",
            "price": "Precio unitario",
            "product_code": "Código de producto",
            "product_name": "Nombre del producto",
            "quantity": "Cantidad",
            "subtotal": "Subtotal",
            "total": "Total",
            "total_cost": "Costo total",
            "unit_cost": "Costo unitario",
            "unit_of_measurement": "Unidad de medida",
            "utility": "Utilidad"
          },
          "currency": "Moneda",
          "date": "Fecha",
          "file_name": "Reporte de Ventas",
          "id": "Cédula",
          "period": "Periodo",
          "range": "Desde %{from} hasta %{to}",
          "report_name": "Reporte de Ventas",
          "sales_with_lines_report": "Ventas con detalle de líneas",
          "summary_sales_report": "Ventas"
        },
        "show": {
          "d104": "Impuestos al valor agregado",
          "purchases": "Compras",
          "purchases_with_lines": "Compras con detalle de líneas",
          "reports": "Reportes",
          "root": "Inicio",
          "sales": "Ventas",
          "sales_with_lines": "Ventas con detalle de líneas"
        }
      },
      "roles": {
        "edit": {
          "title": "Role"
        },
        "index": {
          "created_at": "Creado en",
          "name": "Nombre",
          "title": "Roles"
        },
        "new": {
          "title": "Role"
        },
        "role": {
          "created_at": "Creado en",
          "name": "Nombre",
          "permissions": "Permisos"
        },
        "show": {
          "actions": "Acciones",
          "contacts": "Contactos",
          "create": "Crear",
          "destroy": "Eliminar",
          "exonerations": "Exoneraciones",
          "incomes": "Ingresos",
          "module": "Módulo",
          "outcomes": "Salidas",
          "permission": "Permiso",
          "products": "Productos",
          "purchase_orders": "Órdenes de Compra",
          "read": "Leer",
          "roles": "Roles",
          "sales_orders": "Órdenes de Venta",
          "title": "Role",
          "update": "Editar",
          "users": "Usuarios"
        }
      },
      "sales_orders": {
        "credit_notes": {
          "form": {
            "auto_fill": "Autocompletar",
            "change_selection": "Modificar selección"
          },
          "modal": {
            "header_discount": "Descuento",
            "header_price": "Precio",
            "header_total": "Total",
            "header_total_taxes": "I.V.A.",
            "select_items_text": "Seleccione las líneas del documento que se van a devolver",
            "title": "Nueva devolución"
          },
          "new_return_message": {
            "new_return_button": "Nueva devolución"
          }
        },
        "currency_and_exchange_rate": {
          "exchange_rates": "Tipos de cambio"
        },
        "finalize": {
          "form": {
            "title": "Confirmar orden de venta"
          }
        },
        "form": {
          "tabs": {
            "return": "Devoluciones",
            "sales_order": "Órden"
          }
        },
        "new_sales_order_fields_modal": {
          "title": "Nueva orden de venta"
        },
        "returns_tab_content": {
          "new-return-button": "Nueva devolución",
          "returns_only_available_for_finalized_orders": "Las devoluciones se pueden realizar solamente sobre órdenes finalizadas"
        }
      },
      "vendors": {
        "contact_form": {
          "address": "Dirección"
        },
        "form": {
          "bank_accounts": "Cuentas Bancarias",
          "billing_contact": "Contacto de Facturación",
          "main_contact": "Contacto Principal",
          "secondary_contacts": "Otros Contactos",
          "use_main_contact_for_billing": "Utilizar estos datos para facturación"
        }
      }
    },
    "helpers": {
      "select": {
        "prompt": "Por favor seleccione"
      },
      "submit": {
        "account_connection": {
          "create": "Connectar",
          "update": "Actualizar"
        },
        "create": "Crear %{model}",
        "submit": "Guardar %{model}",
        "update": "Actualizar %{model}",
        "user": {
          "update": "Guardar"
        }
      }
    },
    "i18n": {
      "plural": {
        "keys": [
          "one",
          "other"
        ]
      }
    },
    "import": {
      "error": "Error",
      "no_file": "No se ha seleccionado ningún archivo"
    },
    "inputs": {
      "quantity_with_unit": {
        "select_unit_of_measure": "Seleccione una unidad de medida"
      }
    },
    "irazu": {
      "account_connections": {
        "edit": {
          "header": "Modificar conexión"
        },
        "missing_correlation_error": {
          "correlation_id_not_found": "La connexión no ha sido encontrada en el API."
        },
        "new": {
          "header": "Connectar Cuenta"
        },
        "show": {
          "account_invoicing_integration_not_connected": "No existe una conexión para esta cuenta",
          "certificate_expires_at": "Expira:",
          "certificate_title": "Certificado",
          "certificate_uploaded_at": "Subido:",
          "connect_integration": "Conectar"
        }
      },
      "document_submission_info": {
        "actions": {
          "download_pdf": "Descargar PDF",
          "download_xml": "Descargar XML"
        },
        "labels": {
          "date": "Fecha",
          "document_key": "Llave",
          "status": "Estado"
        }
      },
      "document_types": {
        "1": "Factura Electrónica",
        "2": "Nota de débito",
        "3": "Nota de crédito",
        "4": "Tiquete Electrónico",
        "8": "Factura Electrónica de Compra",
        "9": "Factura Electrónica de Exportación"
      },
      "errors": {
        "500": "Error interno del servidor"
      },
      "payment_method": {
        "1": "Efectivo",
        "2": "Tarjeta",
        "3": "Cheque",
        "4": "Transferencia - depósito bancario",
        "5": "Recaudado por terceros",
        "99": "Otro"
      },
      "sale_condition": {
        "1": "Contado",
        "2": "Crédito",
        "3": "Consignación",
        "4": "Apartado",
        "5": "Arrendamiento con opción de compra",
        "6": "Arrendamiento en función financiera",
        "7": "Cobro a favor de un tercero",
        "8": "Servicios prestados al Estado a crédito",
        "9": "Pago del servicios prestado al Estado",
        "99": "Otros"
      }
    },
    "labels": {
      "activate": "Activos",
      "deactivate": "Inactivos"
    },
    "layouts": {
      "admin_header": {
        "user_menu": {
          "logout": "Salir"
        }
      },
      "header": {
        "settings": "Parámetros",
        "user_menu": {
          "logout": "Salir",
          "view_profile": "Perfil"
        },
        "users": "Usuarios"
      },
      "simple_header": {
        "user_menu": {
          "logout": "Cerrar sesión"
        }
      }
    },
    "list_table": {
      "account": {
        "selected": {
          "one": "%{model_name} seleccionada",
          "other": "%{model_name} seleccionadas"
        }
      },
      "activate_confirmation": {
        "one": "¿Estás seguro de que querés activar este(a) %{record}?",
        "other": "¿Estás seguro de que querés activar estos(as) %{record}?"
      },
      "activate_confirmation_title": "Confirmación de Activación",
      "confirmation_title": "Confirmación",
      "copy_confirmation": {
        "one": "¿Estás seguro de que querés copiar este(a) %{record}?",
        "other": "¿Estás seguro de que querés copiar estos(as) %{record}?"
      },
      "deactivate_confirmation": {
        "one": "¿Estás seguro de que querés desactivar este(a) %{record}?",
        "other": "¿Estás seguro de que querés desactivar estos(as) %{record}?"
      },
      "deactivate_confirmation_title": "Confirmación de desactivación",
      "delete_confirmation": {
        "one": "¿Estás seguro de que querés borrar este(a) %{record}?",
        "other": "¿Estás seguro de que querés borrar estos(as) %{record}?"
      },
      "delete_confirmation_title": "Confirmación de Borrado",
      "selected": {
        "one": "%{model_name} seleccionado(a)",
        "other": "%{model_name} seleccionados(as)"
      }
    },
    "messages": {
      "account": {
        "activated": {
          "one": "La cuenta ha sido activada correctamente",
          "other": "Las cuentas se han activado correctamente"
        },
        "created": {
          "one": "La cuenta se ha creado correctamente",
          "other": "Las cuentas se han creado correctamente"
        },
        "deactivated": {
          "one": "La cuenta ha sido desactivada correctamente",
          "other": "Las cuentas se han desactivado correctamente"
        },
        "destroyed": {
          "one": "La cuenta ha sido borrada correctamente",
          "other": "Las cuentas se han borradas correctamente"
        },
        "updated": {
          "one": "La cuenta se ha actualizado correctamente",
          "other": "Las cuentas se han actualizado correctamente"
        }
      },
      "account_connection": {
        "create": {
          "one": "La cuenta ha sido conectada correctamente"
        },
        "update": {
          "one": "La conexión ha sido actualizada correctamente"
        }
      },
      "account_settings": {
        "update": {
          "one": "El parámetro ha sido actualizado",
          "other": "Los parámetros han sido actualizados"
        }
      },
      "account_user": {
        "activated": {
          "one": "El usuario ha sido activado correctamente",
          "other": "Los usuarios se han activado correctamente"
        },
        "created": {
          "one": "El usuario fue creada correctamente",
          "other": "Los usuarios de usuario fueron creadas correctamente"
        },
        "deactivated": {
          "one": "El usuario ha sido inactivado correctamente",
          "other": "Los usuarios se han inactivado correctamente"
        },
        "destroyed": {
          "one": "El usuario ha sido borrado correctamente",
          "other": "Los usuarios se han borrado correctamente"
        },
        "updated": {
          "one": "El usuario se actualizó correctamente",
          "other": "Los usuarios se actualizaron correctamente"
        }
      },
      "credit_note": {
        "created": {
          "one": "La devolución se ha creado correctamente"
        }
      },
      "customer": {
        "created": {
          "one": "El cliente se ha creado correctamente",
          "other": "Los clientes se han creado correctamente"
        },
        "updated": {
          "one": "El cliente se ha actualizado correctamente",
          "other": "Los clientes se han actualizado correctamente"
        }
      },
      "exoneration": {
        "created": {
          "one": "La exoneración se ha creado correctamente",
          "other": "Las exoneraciones se han creado correctamente"
        },
        "destroyed": {
          "one": "La exoneración ha sido borrada correctamente",
          "other": "Las exoneraciones se han borradas correctamente"
        },
        "updated": {
          "one": "La exoneración se ha actualizado correctamente",
          "other": "Las exoneraciones se han actualizado correctamente"
        }
      },
      "inventory_adjustment": {
        "created": {
          "one": "El ajuste de inventario se ha creado correctamente"
        },
        "updated": {
          "one": "El ajuste de inventario se ha actualizado correctamente"
        }
      },
      "location": {
        "created": {
          "one": "La ubicación se ha creado correctamente",
          "other": "Las ubicaciones se han creado correctamente"
        },
        "destroyed": {
          "one": "La ubicación ha sido borrada correctamente",
          "other": "Las ubicaciones se han borrado correctamente"
        },
        "updated": {
          "one": "La ubicación se ha actualizado correctamente",
          "other": "Las ubicaciones se han actualizado correctamente"
        }
      },
      "password": {
        "blank": "nueva contraseña no puede estar en blanco",
        "updated": {
          "one": "La contraseña se actualizó correctamente",
          "other": "Las contraseñas se actualizaron correctamente"
        }
      },
      "physical_inventory": {
        "created": {
          "one": "El inventario físico se ha creado correctamente",
          "other": "Los inventarios físicos se han creado correctamente"
        },
        "destroyed": {
          "one": "El inventario físico ha sido borrado correctamente",
          "other": "Los inventarios físicos se han borrado correctamente"
        },
        "updated": {
          "one": "El inventario físico se ha actualizado correctamente",
          "other": "Los inventarios físicos se han actualizado correctamente"
        }
      },
      "pricing_list": {
        "created": {
          "one": "La lista de precios se ha creado correctamente",
          "other": "Las listas de precios se han creado correctamente"
        },
        "updated": {
          "one": "La lista de precios se ha actualizado correctamente",
          "other": "Las listas de precios se han actualizado correctamente"
        }
      },
      "pricing_plan": {
        "activated": {
          "one": "El plan ha sido activado correctamente",
          "other": "Los planes se han activado correctamente"
        },
        "created": {
          "one": "El plan se ha creado correctamente",
          "other": "Los planes se han creado correctamente"
        },
        "deactivated": {
          "one": "El plan ha sido desactivado correctamente",
          "other": "Los planes se han desactivado correctamente"
        },
        "destroyed": {
          "one": "El plan ha sido borrado correctamente",
          "other": "Los planes se han borrado correctamente"
        },
        "updated": {
          "one": "El plan se ha actualizado correctamente",
          "other": "Los planes se han actualizado correctamente"
        }
      },
      "product": {
        "activated": {
          "one": "El producto ha sido activado correctamente",
          "other": "Los productos se han activado correctamente"
        },
        "created": {
          "one": "El producto se ha creado correctamente",
          "other": "Los productos se han creado correctamente"
        },
        "deactivated": {
          "one": "El producto ha sido desactivado correctamente",
          "other": "Los productos se han desactivado correctamente"
        },
        "updated": {
          "one": "El producto se ha actualizado correctamente",
          "other": "Los productos se han actualizado correctamente"
        }
      },
      "profiles": {
        "updated": {
          "one": "Tu perfil se ha actualizado correctamente"
        }
      },
      "purchase_order": {
        "created": {
          "one": "La orden de compra se ha creado correctamente"
        },
        "updated": {
          "one": "La orden de compra se ha actualizado correctamente"
        }
      },
      "role": {
        "activated": {
          "one": "El rol ha sido activado correctamente",
          "other": "Los roles se han activado correctamente"
        },
        "created": {
          "one": "El rol se ha creado correctamente",
          "other": "Los roles se han creado correctamente"
        },
        "deactivated": {
          "one": "El rol ha sido desactivado correctamente",
          "other": "Los roles se han desactivado correctamente"
        },
        "errors": {
          "has_account_users": "El rol no se puede desactivar porque tiene usuarios asociados."
        },
        "updated": {
          "one": "El rol se ha actualizado correctamente",
          "other": "Los roles se han actualizado correctamente"
        }
      },
      "sales_order": {
        "created": {
          "one": "La orden de venta se ha creado correctamente"
        },
        "finalized": {
          "one": "La orden de venta se ha finalizado correctamente"
        },
        "updated": {
          "one": "La orden de venta se ha actualizado correctamente"
        }
      },
      "user": {
        "activated": {
          "one": "El usuario se ha activado correctamente",
          "other": "Los usuarios se han activado correctamente"
        },
        "created": {
          "one": "El usuario se ha creado correctamente",
          "other": "Los usuarios se han creado correctamente"
        },
        "deactivated": {
          "one": "El usuario fue desactivado correctamente",
          "other": "Los usuarios fueron desactivados correctamente"
        },
        "updated": {
          "one": "El usuario se actualizó correctamente",
          "other": "Los usuarios se actualizaron correctamente"
        }
      },
      "vendor": {
        "created": {
          "one": "El vendedor se ha creado correctamente",
          "other": "Los vendedores se han creado correctamente"
        },
        "updated": {
          "one": "El vendedor se ha actualizado correctamente",
          "other": "Los vendedores se han actualizado correctamente"
        }
      }
    },
    "notifications": {
      "certificate_expired": "La llave criptográfica expiró hace %{days}",
      "certificate_expires_soon": "La llave criptográfica expirará en %{days}",
      "document_notification": {
        "sales_order": {
          "accepted": {
            "message": "El orden de venta %{number} ha sido aceptada.",
            "title": "%{document} aceptada"
          },
          "rejected": {
            "message": "El orden de venta %{number} ha sido rechazada.",
            "title": "%{document} rechazada"
          },
          "submitted": {
            "message": "La orden de venta %{number} ha sido enviada.",
            "title": "%{document} enviada"
          }
        }
      },
      "empty": "No hay notificaciones",
      "notification": "",
      "title": "Notificaciones"
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u %n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "¢"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 2,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil millones",
            "million": {
              "one": "millón",
              "other": "millones"
            },
            "quadrillion": "mil billones",
            "thousand": "mil",
            "trillion": {
              "one": "billón",
              "other": "billones"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": ",",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": ",",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ","
        }
      }
    },
    "pagy": {
      "combo_nav_js": "<label>Página %{page_input} de %{pages}</label>",
      "info": {
        "multiple_pages": "Mostrando %{item_name} %{from}-%{to} de %{count} en total",
        "no_items": "Sin resultados",
        "single_page": "Mostrando %{count} %{item_name}"
      },
      "item_name": {
        "one": "ítem",
        "other": "ítems"
      },
      "items_selector_js": "<label>Mostrar %{items_input} %{item_name} por página</label>",
      "nav": {
        "gap": "&hellip;",
        "next": "Siguiente&nbsp;&rsaquo;",
        "prev": "&lsaquo;&nbsp;Anterior"
      }
    },
    "paper_trail": {
      "events": {
        "create": "Creación",
        "destroy": "Eliminado",
        "update": "Actualización"
      }
    },
    "pdf": {
      "discount": "Descuento",
      "document_number": "Factura",
      "document_to": "Cliente",
      "factura_electronica": {
        "consecutive": "Consecutivo",
        "currency": "Moneda",
        "date": "Fecha",
        "document_number": "Factura",
        "document_types": {
          "1": "Factura Electrónica",
          "2": "Nota de débito",
          "3": "Nota de crédito",
          "4": "Tiquete Electrónico",
          "8": "Factura Electrónica de Compra",
          "9": "Factura Electrónica de Exportación"
        },
        "due_at": "Vence",
        "exchange_rate": "TC",
        "key": "Clave",
        "payment_method": "Forma de pago",
        "sale_condition": "Condición de venta"
      },
      "items": {
        "price": "Precio",
        "quantity": "Cantidad",
        "title": "Ítem",
        "total": "Total"
      },
      "page_number": "Página %{page} de %{count}",
      "subtotal": "Subtotal",
      "taxes": "Impuesto",
      "total": "Total"
    },
    "ransack": {
      "attributes": {
        "customer": {
          "main_contact_name": "Contacto Principal"
        },
        "vendor": {
          "main_contact_name": "Contacto Principal"
        }
      }
    },
    "roles": {
      "super_admin": "Super Administrador"
    },
    "sidebar": {
      "dashboard": "Escritorio",
      "income": "Entradas",
      "inventory": "Inventario",
      "purchases": "Compras",
      "reports": "Reportes",
      "sales": "Ventas"
    },
    "simple_form": {
      "buttons": {
        "submit": {
          "pricing_list_product": {
            "create": "Agregar"
          }
        }
      },
      "error_notification": {
        "default_message": "Por favor revise los siguientes errores:"
      },
      "hints": {
        "account": {
          "general_regional_delimiter": "Separador de miles",
          "general_regional_precision": "Cantidad de decimales a mostrar",
          "general_regional_separator": "Separador entre las unidades",
          "general_regional_strip_insignificant_zeros": "Eliminar ceros a la derecha de los decimales. Ejemplo: 1.00 -> 1 y 1.40 -> 1.4"
        }
      },
      "labels": {
        "exchange_rates": {
          "crc": "Colón Costarrisence (CRC)",
          "eur": "Euro (EUR)",
          "usd": "Dólar Americano (USD)"
        },
        "pricing_list_product": {
          "product": "Selecione al menos un producto"
        },
        "product": {
          "products": {
            "product": "Producto",
            "type": "Tipo",
            "value": "Valor"
          }
        },
        "q": {
          "date_time_between_from": "Fecha Desde",
          "date_time_between_to": "Fecha Hasta",
          "products": {
            "categories_products_category_id_in": "Categorías"
          }
        }
      },
      "no": "No",
      "placeholders": {
        "inventory_adjustment": {
          "number": "Número de ajuste"
        },
        "product": {
          "description": "Descripción del producto"
        },
        "purchase_order": {
          "number": "Número de factura"
        },
        "sales_order": {
          "number": "Número de factura"
        }
      },
      "prompts": {
        "account_user": {
          "location_ids": {
            "empty_collection": "No existen ubicaciones"
          }
        },
        "empty_collection": "No hay opciones"
      },
      "required": {
        "mark": "*",
        "text": "requerido"
      },
      "yes": "Sí"
    },
    "support": {
      "array": {
        "last_word_connector": " y ",
        "two_words_connector": " y ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "datepicker": "%d/%m/%Y %H:%M %p",
        "default": "%d/%m/%Y %H:%M %p",
        "document_pdf": "%d de %B de %Y a las %l:%M %p",
        "long": "%A, %d de %B de %Y a las %I:%M %p",
        "long_date": "%d %B %Y %H:%M:%S",
        "short": "%d de %b a las %H:%M hrs"
      },
      "pm": "pm"
    },
    "time_ago": "Hace %{time_ago}",
    "titles": {
      "clear_search_filters": "Hacé click aquí para limpiar los filtros de búsqueda y mostrar todos los resultados",
      "create_first_resource": "¿Qué esperas? ¡Crea tu primer %{model_name}!",
      "edit_resource": "Editar %{model_name}",
      "empty_resource": "No existen aún",
      "empty_search_results": "No se encontraron resultados",
      "new_resource": "Nuevo %{model_name}",
      "unauthorized": "Lo sentimos, el recurso solicitado no existe o no tenés permisos para verlo."
    },
    "toast": {
      "alert": "Alerta",
      "info": "Información",
      "messages": {
        "unauthorized": "Acceso denegado"
      },
      "notice": "Aviso",
      "primary": "Alerta",
      "secondary": "Alerta",
      "success": "Aviso",
      "warning": "Advertencia"
    }
  }
}